import { render } from "./UroPlasterBondPage.vue?vue&type=template&id=73a72f75"
import script from "./UroPlasterBondPage.vue?vue&type=script&lang=js"
export * from "./UroPlasterBondPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__